/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./DaJieTiao.vue?vue&type=template&id=6823073a&scoped=true&"
import script from "./DaJieTiao.vue?vue&type=script&lang=js&"
export * from "./DaJieTiao.vue?vue&type=script&lang=js&"
import style0 from "./DaJieTiao.vue?vue&type=style&index=0&id=6823073a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6823073a",
  null
  
)

export default component.exports